export const format = (numStr: string) => {
    if (numStr === "") return "";
    return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
    }).format(parseFloat(numStr));
};

export const currency = (number: number) => {

    return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
    }).format(number);
};

export const number = (number: number) => {
    // Melakukan pembulatan ke atas menggunakan Math.ceil()
    const roundedNumber = Math.ceil(number);

    // Menggunakan Intl.NumberFormat untuk memformat angka
    return new Intl.NumberFormat().format(roundedNumber);
};


export const check_int = (evt: any) => {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    // eslint-disable-next-line no-mixed-operators
    return (charCode >= 46 && charCode <= 57 || charCode === 8);
};


export const numberOnly = (value: string) => {
    const re = /^[0-9\b]+$/;
    if (value === "" || re.test(value)) {
        return value;
    }
};